// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__37m9o","green":"checkbox_green__2Rcki","danger":"checkbox_danger__3vTmB","disabled":"checkbox_disabled__2rq_p"};